/**
 * Error Modal
 * Dislay error messages
 */
import React from "react"
import PropTypes from "prop-types"
import { AlignText } from "./styles"
import { CloseButton } from "styles/Modal"
import Modal from "components/Modal"
import Text from "components/Text"
import Icon from "components/Icon"
import TextButton from "components/TextButton"

export const ErrorModal = ({
  isModalOpen,
  onClose,
  title,
  message,
  messageHTML,
  align = "center",
  showClose,
}) => {
  return (
    <Modal open={isModalOpen} title={title} align={align}>
      <CloseButton onClick={onClose}>
        <Icon variant={"cross_lrg"} />
      </CloseButton>
      <Text variant={"text"}>
        {messageHTML ? (
          messageHTML
        ) : (
          <AlignText
            align={align}
            dangerouslySetInnerHTML={{ __html: message }}
          />
        )}
      </Text>
      {showClose ? (
        <TextButton
          style={{ marginTop: "20px", padding: "0" }}
          label={"Close"}
          onClick={onClose}
        />
      ) : null}
    </Modal>
  )
}

ErrorModal.propTypes = {
  closeModal: PropTypes.func,
  isModalOpen: PropTypes.bool,
}
export default ErrorModal
